import { Flex } from '@mantine/core';
import { Icon } from '@repo/foundations';
import { filter, map } from 'lodash-es';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useSuspenseFeatureAccess } from '../../../api';
import { useUnreadNotificationCount } from '../../../api/hooks/notification';
import { useAiWorkspaceSettingEnabled } from '../../../hooks/useAiWorkspaceSettingEnabled';
import { useOnboarding } from '../../../hooks/useOnboarding';
import { ensurePositive } from '../../../utils/utils';
import { isActive } from '../utils';
import type { Link } from './SideBarLink';
import SideBarLink from './SideBarLink';

function SideBarHeader() {
	const { showOnboarding, stepsTotal, stepsCompleted } = useOnboarding();
	const { data: unreadCount } = useUnreadNotificationCount();

	const enableAi = useAiWorkspaceSettingEnabled();
	const { secodaCoreAccess } = useSuspenseFeatureAccess();

	const location = useLocation();

	const headerLinks: Array<Link> = useMemo(
		() => [
			{
				id: 'nav::home',
				label: 'Home',
				icon: <Icon name="home" color="icon/primary/default" />,
				href: ['/', '/home'],
				matchExact: true,
				show: !!secodaCoreAccess,
				showCount: showOnboarding,
				count: ensurePositive(stepsTotal - stepsCompleted),
			},
			{
				id: 'nav::inbox',
				label: 'Inbox',
				icon: <Icon name="inbox" color="icon/primary/default" />,
				href: ['/inbox'],
				show: !!secodaCoreAccess,
				showCount: true,
				count: ensurePositive(unreadCount),
			},
			{
				label: 'Secoda AI',
				id: 'nav::suggestions',
				href: ['/ai/new', '/ai'],
				icon: <Icon name="sparkles" color="icon/primary/default" />,
				show: enableAi,
				matchExact: false,
			},
		],
		[
			enableAi,
			showOnboarding,
			stepsCompleted,
			stepsTotal,
			unreadCount,
			secodaCoreAccess,
		]
	);

	return (
		<Flex direction="column" pr="xs" align="flex-start">
			{map(filter(headerLinks, 'show'), (link) => (
				<SideBarLink
					key={link.id}
					link={link}
					selected={isActive(link.href, location, Boolean(link.matchExact))}
				/>
			))}
		</Flex>
	);
}

const ObservedSideBarHeader = observer(SideBarHeader);
export default ObservedSideBarHeader;
